export default class Initializer {
  static run(vidioObj= window.vidio){
    let action, controllerObj, init, initAction;
    let body = document.getElementById("body");

    if (body === null) return;
    action = body.getAttribute("data-action");

    try {
      controllerObj = body
                      .getAttribute("data-controller")
                      .split("/")
                      .reduce((obj, value) => { return obj[value] }, vidioObj);

      init = controllerObj['init'];
      initAction = controllerObj[`init_${action}`];

      Initializer.perform(controllerObj, init);
      Initializer.perform(controllerObj, initAction);
    } catch(e){ console.warn("Initializer.run: initializer is not set for this page"); }
  }

  static perform(obj, func){
    if(typeof func !== "function") return;
    try { func.bind(obj)(); } catch(e) { console.error("Initializer.perform:", e); }
  }
}
